module.exports = __webpack_public_path__ + "assets/webgl/360_vignes.jpg.pvr.e005369c.ktx";